import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/label';

export class Spojovacka implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 20;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const page = pdf.addPage();
    const random = opts.data?.random;

    const count = Math.min(opts.list.length, 50);
    if (count === 0) return;

    const margin = PdfUnit.FromMillimeters(10);
    const margin2 = PdfUnit.FromMillimeters(5);

    const leftRectWidth = PdfUnit.FromMillimeters(40);
    const rightRectWidth = PdfUnit.FromMillimeters(40);
    const cellHeight = (PdfSize.A4.height - 2 * margin) / count;
    const originX = margin;
    const originY = margin;

    const items = opts.list.slice(0, count);

    const leftTexts = items.map((t) => [t.left.getText() ?? '']);
    const rightTexts = items.map((t) => [t.right.getText() ?? '']);

    const f1 = page.adjustFontMulti(
      leftTexts,
      GUtil.baseFont,
      new PdfSize(leftRectWidth, cellHeight)
    );
    const f2 = page.adjustFontMulti(
      rightTexts,
      GUtil.baseFont,
      new PdfSize(rightRectWidth, cellHeight)
    );

    const indices = Array.from({ length: count }, (_, i) => i);
    if (random) {
      for (let i = indices.length - 1; i > 0; i--) {
        const j = random.next(0, i + 1);
        [indices[i], indices[j]] = [indices[j], indices[i]];
      }
    }

    for (let i = 0; i < count; i++) {
      const r1 = new PdfRect(originX, originY + i * cellHeight, leftRectWidth, cellHeight);
      const r2 = new PdfRect(
        PdfSize.A4.width - margin - rightRectWidth,
        originY + i * cellHeight,
        rightRectWidth,
        cellHeight
      );

      const c1 = new PdfRect(
        r1.right + margin2,
        r1.centerY - GUtil.circleHandleSize / 2,
        GUtil.circleHandleSize,
        GUtil.circleHandleSize
      );
      const c2 = new PdfRect(
        r2.left - margin2 - GUtil.circleHandleSize,
        r1.centerY - GUtil.circleHandleSize / 2,
        GUtil.circleHandleSize,
        GUtil.circleHandleSize
      );

      const shuffledIdx = indices[i];
      page.drawLabel(items[shuffledIdx].left, { rect: r1, font: f1 });
      page.drawLabel(items[i].right, { rect: r2, font: f2 });

      page.drawEllipse(GUtil.basePen, null, c1);
      page.drawEllipse(GUtil.basePen, null, c2);
    }
  }
}
